import * as React from 'react'
import {
  makeStyles,
  Box,
  CircularProgress,
  Tabs,
  Tab,
  Fade,
} from '@material-ui/core';
import { PortalContext, HomeWidgetError, HomeWidgetVacio } from '@portal/arq-portal-core';
import { InformeMicroStrategy } from '../types/types';
import useInformesAutos from '../hooks/informesAutos';

const useStyles = makeStyles({
  publicacionesTab: {
      '& .MuiTab-wrapper': {
          display: 'flex',
          flexDirection: 'row-reverse',
          padding: '0 80px'
      }
  },
  publicacionesIcon: {
      width: '18px',
      marginBottom: '0px !important',
      marginLeft: '10px',
  },
  tabSection: {
      borderTop: '1px solid #d6d8d8',
      '& .MuiTabs-indicator': {
          top: '0px',
          height: '4px',
      },
      '& .MuiTab-textColorInherit.Mui-selected': {
          fontWeight:'bold',
          color: '#606060',
          borderBottom: '1px solid transparent',
          borderLeft: '1px solid transparent',
          borderRight: '1px solid transparent',
          PointerEvent: 'none',
      },
      '& .MuiTab-root': {
          borderBottom: '1px solid #d6d8d8',
          borderLeft: '1px solid #d6d8d8',
          borderRight: '1px solid #d6d8d8',
          color: '#606060',
          opacity: '1',
          '& .MuiTouchRipple-root': {
              display: 'none',
          }
      },
      '& .MuiTab-labelIcon': {
          minHeight: '48px',
      },

  },
  menuPersonasTab : {
      '& .MuiTab-wrapper': {
          display: 'flex',
          flexDirection: 'row',
          gap: 10,
          '& .MuiCircularProgress-root': {
              order: 1
          }
      }
  },
  tabIcono: {
      display: 'block'
  },
  oculto: {
      display: 'none' 
  },
  tabContent: {
    padding: '15px 60px',
    '@media screen and (max-width: 959px)': {
        padding: '15px 20px',
    },
  },
  fichaLoading:{
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center'
  },

  fichaAutos: {
    backgroundColor: '#ffffff',
    padding: '1.5rem',
    color: '#606060',
    fontFamily: 'CO-Bold',
    '& h3': {
        fontSize: '18px',
        marginBottom: '10px',
        paddingBottom: '15px',
        borderBottom: '1px solid #919191'
    }
  },
  wrapperFicha:{
    '@media screen and (min-width: 992px)': {
      width:'50%',
    },
    padding: '1.5rem', 

  },
  contenedor: {
    display: 'block',
    width: '100%',
    maxHeight: '243px',
  }
} 
);




export const InformesAutos = (props:any) => {

  const {user} = React.useContext(PortalContext);
  const {data, error} = useInformesAutos(user?user.id:"");
  let errorMessage = error?.message ? error.message : error?.mensaje ? error.mensaje : error;
  let informes: InformeMicroStrategy[]  = props?.informes? props.informes: data?.Salida?.InformesMicroStrategy;

  const classes = useStyles(props);
  const [currentTab, setCurrentTab] = React.useState(0);
  const [isLoaded, setIsLoaded] = React.useState(false);
  
  // @ts-ignore
  const manejarCambio = (event: React.SyntheticEvent, nuevoValor: number) => {
    setCurrentTab(nuevoValor);
    setIsLoaded(false);
  };
  
  return <React.Fragment>
    <div className = {classes.wrapperFicha}> 
    <div className={classes.fichaAutos}>
      <h3> Reportes Microstrategy</h3>
      {!data && !errorMessage && <div className={classes.fichaLoading}><CircularProgress color="primary" size={30} thickness={2} className={classes.tabIcono}/> </div>}
      {!data && errorMessage && <div className={classes.contenedor}><HomeWidgetError error={errorMessage} /></div>}
      {data && informes?.length === 0 && <div className={classes.contenedor}><HomeWidgetVacio mensaje="No hay informes" /></div>}
      {data && informes?.length > 0 &&
      <Box sx={{ width: 'auto' }} style={{ background: 'white', marginTop: '20px' }} className={classes.tabSection}>
          <Tabs
              value={currentTab}
              onChange={manejarCambio}
              indicatorColor="primary"
              textColor="inherit"
              variant="fullWidth"
              aria-label="pestañas de búsqueda"
          >
              {informes && informes.map((inf:any,index:any) => {
                return <Tab className={classes.menuPersonasTab} key={index}
                      label={inf.NombreDelInforme}
                      icon={<CircularProgress color="primary" size={16} thickness={2} className={`${(currentTab == index && !isLoaded) ? classes.tabIcono : classes.oculto}`}/>}
                    />
                })
              }
          </Tabs>
            {currentTab != null &&  
                <div>
                  {
                    <Fade in={isLoaded} timeout={1000}>
                      <iframe 
                        name="__MAINFRAME__"
                        className="site-layout-content-iframe"
                        sandbox="allow-scripts allow-same-origin allow-top-navigation allow-forms allow-popups allow-pointer-lock allow-popups-to-escape-sandbox allow-modals"
                        allow="camera;microphone"
                        seamless
                        src={informes[currentTab].UrlDelInforme ?? undefined}
                        style={{
                          width: "1px",
                          minWidth: "100%",
                          border: "0px",
                          display: isLoaded ? "block" : "none",
                          minHeight: "calc(100vh - 52px)",
                          backgroundColor: "#ffffff"
                        }}
                        onLoad={() => {
                          setIsLoaded(true);
                        }}
                      />
                    </Fade> 
                  }
                </div>
              }
      </Box>}
    </div>
    </div>
  </React.Fragment>
}